import { FC } from 'react';
import { DealType } from '../../../../../enums/DealType';
import { useDealType } from '../../../../../hooks/UseDealType';
import { PortfolioBadge } from '../../../../style';

type DealTypeProps = {
  dealType: number;
};

const DealTypeColumn: FC<DealTypeProps> = (props) => {
  const { getColorCode, getDealTypeLabel } = useDealType();
  const dealTypeLabel = getDealTypeLabel(props.dealType);
  return (
    <div data-testid='deal-type-icon'>
      <PortfolioBadge backgroundColor={getColorCode(dealTypeLabel)}>
        {getDealTypeLabel(props.dealType) === DealType.New
          ? 'NEW CUST.'
          : getDealTypeLabel(props.dealType)}
      </PortfolioBadge>
    </div>
  );
};

export default DealTypeColumn;
